export default __webpack_public_path__ + "c04cf46a9a2e76683d1baa49ddeba54a.png";